<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      autocomplete="off"
      class="form-control"
      @change="emit"
      @input="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'VisitorEmployeeNumberInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Табельный номер'
    },

    inputName: {
      default: 'employee_number'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId() {
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-employee-number`
      }
      return `form-visitor-employee-number-${this.visitorIndex}`
    }
  }
}
</script>
